/// <reference path="../../types/signalr.d.ts" />

namespace SP {
    export class Point {

        static zero = new Point(0, 0);
        static left = new Point(-1, 0);
        static right = new Point(1, 0);
        static up = new Point(0, -1);
        static down = new Point(0, 1);

        x: number;
        y: number;

        constructor(x: number = null, y: number = null) {
            this.set(x, y);
        }

        set(x: number = null, y: number = null) {
            this.x = x ?? 0;
            this.y = y ?? x ?? 0;
        }



        static Distance(a: Point, b: Point) {
            var aa = a.x - b.x;
            var bb = a.y - b.y;
            return Math.sqrt(aa * aa + bb * bb);
        }

        distance(b: Point) {
            return Point.Distance(this, b);
        }

        length() {
            return Point.Distance(this, Point.zero);
        }


    }
}